import React, { useEffect, useState } from "react";
import FilterButton from "../../FilterButton";
import {
  Box,
  Checkbox,
  DialogContent,
  FormControlLabel,
  Grid,
  LinearProgress,
  MenuItem,
  Stack,
} from "@mui/material";
import { useSelector } from "react-redux";
import {
  selectActiveSession,
} from "app/modules/schools/selectors";
import CommonFilterDialog from "../CommonFilterDialog";
import ByClassFilter from "app/components/commonSeperateMultipleFilter/ByClassFilter";
import { useQuery } from "react-query";
import {
  getAllRouteList,
  getTransportationFeeStructure,
} from "app/services/schoolService/transport.service";
import TextFieldLabel from "../../TextFieldLabel";
import { CustomSelectBox } from "assets/styles/globalStyledComponent";
import Chip from "../../CustomChip";
import { IndianCurrency } from "app/utils/helper";
import ByVehicleFilter from "app/components/commonSeperateMultipleFilter/ByVehicleFilter";

const CheckBoxComponent = ({
  onChange = () => {},
  checked,
  label = "Label",
}) => {
  return (
    <FormControlLabel
      checked={checked}
      onChange={onChange}
      control={<Checkbox color="secondary" />}
      label={label}
      componentsProps={{
        typography: {
          sx: { fontSize: "13px", fontWeight: 600 },
        },
      }}
    />
  );
};

const TransportStudentMapFilter = ({ mutate = () => {} }) => {
  const selectedSession = useSelector(selectActiveSession);
  const [selectedClasses, setSelectedClasses] = useState([]);
  const [selectedVehicles, setSelectedVehicles] = useState([]);
  const [classListToMutate, setClassListToMutate] = useState([]);

  const [state, setState] = useState({
    dialog: false,
    reqFeeStructureList: [],
    feeStructureList: [],
    routeDetailsList: [],
    selectedRouteNumber: "",
    selectedRangeCode: "",  
    selectedUsing: "Yes",
    selectedRangeList: [],
  });
  const [filters, setFilters] = useState({
    class: {
      classDocId: "",
      section: "",
    },
  });
  const [checkboxes, setCheckboxes] = useState({
    class: false,
    vehicleNumber: false,
    routeInfo: false,
    feeStructure: false,
    using: true,
  });

  const handleCloseFilterDialog = () => {
    setState((prev) => ({ ...prev, dialog: false }));
  };

  const handleView = () => {
    handleCloseFilterDialog();
    const body = {
      ...(checkboxes.class && {
        ...(classListToMutate.length > 0 && {
          classList: JSON.stringify(classListToMutate),
        }),
      }),
      ...(checkboxes.vehicleNumber &&
        selectedVehicles.length > 0 && {
          reqVehicleNumberList: JSON.stringify(
            selectedVehicles
              ?.filter((item) => item?.checked)
              ?.map((item) => item?.vehicleNumber)
          ),
        }),

      ...(checkboxes.feeStructure && {
        reqTransportFeeDocIdList: JSON.stringify(state.reqFeeStructureList),
      }),
      ...(checkboxes.routeInfo && {
        routeNumber: state.selectedRouteNumber,
        rangeCode: state.selectedRangeCode,
      }),
      ...(checkboxes.using && state.selectedUsing && {
        using: state.selectedUsing,
      }),
    };
    mutate(body);
  };

  const {
    isLoading: getTransportationFeeStructureLoading,
    isFetching: getTransportationFeeStructureFetching,
  } = useQuery({
    queryKey: ["getTransportationFeeStructure", selectedSession],
    queryFn: () => getTransportationFeeStructure({ session: selectedSession }),
    onSuccess: (res) => {
      setState((prev) => ({
        ...prev,
        feeStructureList: res?.data?.list,
      }));
    },
    enabled: checkboxes.feeStructure ? true : false,
  });

  const {
    isLoading: getAllRouteListLoading,
    isFetching: getAllRouteListFetching,
  } = useQuery({
    queryKey: ["getAllRouteList", selectedSession],
    queryFn: () => getAllRouteList({ session: selectedSession }),
    onSuccess: (res) => {
      setState((prev) => ({
        ...prev,
        routeDetailsList: res?.data?.list ?? [],
      }));
    },
    enabled: checkboxes.routeInfo ? true : false,
  });

  useEffect(() => {
    const filteredList = selectedClasses?.map(({ classDocId, section }) => ({
      classDocId,
      section,
    }));
    setClassListToMutate(filteredList);
  }, [selectedClasses]);

  return (
    <>
      <FilterButton
        handleClick={() => setState((prev) => ({ ...prev, dialog: true }))}
        count={Object.values(checkboxes).filter((item) => item === true).length}
      />

      <CommonFilterDialog
        open={state.dialog}
        onClose={handleCloseFilterDialog}
        handleSaveAndView={handleView}
        title="Filter"
      >
        <DialogContent>
          {getTransportationFeeStructureFetching ||
          getAllRouteListFetching ||
          getAllRouteListLoading ||
          getTransportationFeeStructureLoading ? (
            <LinearProgress
              sx={{
                width: "100%",
              }}
            />
          ) : null}

          {/* Trans. Using */}
          <Box>
            <CheckBoxComponent
              checked={checkboxes.using}
              onChange={(e) => {
                setCheckboxes((prev) => ({
                  ...prev,
                  using: !prev.using,
                }));
              }}
              label="Using"
            />
            {checkboxes.using && (
              <Grid container spacing={1.5}>
                <Grid xs={12} item>
                  <TextFieldLabel title="Using" />
                  <CustomSelectBox
                    displayEmpty
                    size="small"
                    fullWidth
                    value={state.selectedUsing}
                    onChange={(e) =>
                      setState((prev) => ({
                        ...prev,
                        selectedUsing: e.target.value,
                      }))
                    }
                  >
                    <MenuItem value="Yes">Yes</MenuItem>
                    <MenuItem value="No">No</MenuItem>
                  </CustomSelectBox>
                </Grid>
              </Grid>
            )}
          </Box>

          {/* vehicle number */}
          <Box>
            <CheckBoxComponent
              checked={checkboxes.vehicleNumber}
              onChange={(e) => {
                setFilters((prev) => ({
                  ...prev,
                  vehicleNumber: "",
                }));
                setCheckboxes((prev) => ({
                  ...prev,
                  vehicleNumber: !prev.vehicleNumber,
                }));
              }}
              label="Vehicle Number"
            />
            {checkboxes.vehicleNumber && (
              <ByVehicleFilter
                prevVehicleList={selectedVehicles}
                setSelectedVehicles={setSelectedVehicles}
              />
            )}
          </Box>
          {/* class info */}
          <Box>
            <CheckBoxComponent
              checked={checkboxes.class}
              onChange={(e) => {
                setFilters((prev) => ({
                  ...prev,
                  class: {
                    ...prev.class,
                    classDocId: "",
                    section: "",
                  },
                }));
                setCheckboxes((prev) => ({
                  ...prev,
                  class: !prev.class,
                }));
              }}
              label="Class Info"
            />
            {checkboxes.class && (
              <ByClassFilter
                prevClassList={selectedClasses}
                setSelectedClasses={setSelectedClasses}
              />
            )}
          </Box>
          {/* route info */}
          <Box>
            <CheckBoxComponent
              checked={checkboxes.routeInfo}
              onChange={(e) => {
                setFilters((prev) => ({
                  ...prev,
                  routeInfo: "",
                }));
                setCheckboxes((prev) => ({
                  ...prev,
                  routeInfo: !prev.routeInfo,
                }));
              }}
              label="Route Info"
            />
            {checkboxes.routeInfo && (
              <Grid container spacing={1.5}>
                <Grid xs={6} item>
                  <TextFieldLabel title="Route Number" />
                  <CustomSelectBox
                    displayEmpty
                    size="small"
                    fullWidth
                    value={state.selectedRouteNumber}
                  >
                    <MenuItem disabled value="">
                      Select
                    </MenuItem>
                    {state?.routeDetailsList?.map((item) => (
                      <MenuItem
                        key={item?._id}
                        value={item?.routeNumber}
                        onClick={() => {
                          setState((prev) => ({
                            ...prev,
                            selectedRouteNumber: item?.routeNumber,
                            selectedRangeList: item?.rangeList,
                          }));
                        }}
                      >
                        {item?.routeNumber} ({`Route Name: ${item?.routeName}`})
                      </MenuItem>
                    ))}
                  </CustomSelectBox>
                </Grid>
                <Grid xs={6} item>
                  <TextFieldLabel title="Route Code" />
                  <CustomSelectBox
                    displayEmpty
                    size="small"
                    fullWidth
                    value={state.selectedRangeCode}
                  >
                    <MenuItem disabled value="">
                      Select
                    </MenuItem>
                    {state?.selectedRangeList?.map((item) => (
                      <MenuItem
                        key={item?._id}
                        value={item?.rangeCode}
                        onClick={() => {
                          setState((prev) => ({
                            ...prev,
                            selectedRangeCode: item?.rangeCode,
                          }));
                        }}
                      >
                        {item?.rangeCode} (
                        {`${item?.fromDistance} - ${item?.toDistance} KM (${item?.toStopName})`}
                        )
                      </MenuItem>
                    ))}
                  </CustomSelectBox>
                </Grid>
              </Grid>
            )}
          </Box>
          {/* fee struture */}
          <Box>
            <CheckBoxComponent
              checked={checkboxes.feeStructure}
              onChange={(e) => {
                setFilters((prev) => ({
                  ...prev,
                  feeStructure: "",
                }));
                setCheckboxes((prev) => ({
                  ...prev,
                  feeStructure: !prev.feeStructure,
                }));
              }}
              label="Fee Structure"
            />
            {checkboxes.feeStructure && (
              <Grid container spacing={1.5}>
                <Grid xs={12} item>
                  <TextFieldLabel title="Fee Structure" />
                  <CustomSelectBox
                    displayEmpty
                    size="small"
                    fullWidth
                    multiple
                    value={state.reqFeeStructureList}
                    renderValue={() => {
                      if (state.reqFeeStructureList.length === 0)
                        return "Select";
                      return state.feeStructureList
                        ?.filter((item) =>
                          state.reqFeeStructureList.includes(item?._id)
                        )
                        ?.map(
                          (item) =>
                            state?.feeStructureList?.find(
                              (fee) => fee?._id === item?._id
                            )?.feeCode
                        )
                        ?.join(", ");
                    }}
                  >
                    <MenuItem disabled value="">
                      Select
                    </MenuItem>
                    {state?.feeStructureList?.map((item) => (
                      <Box key={item?._id} sx={{ px: 1 }}>
                        <FormControlLabel
                          control={
                            <Checkbox
                              color="secondary"
                              checked={state.reqFeeStructureList?.includes(
                                item?._id
                              )}
                              onChange={() => {
                                const newFeeStructureList =
                                  state.reqFeeStructureList.includes(item?._id)
                                    ? state.reqFeeStructureList.filter(
                                        (docId) => docId !== item?._id
                                      )
                                    : [...state.reqFeeStructureList, item?._id];
                                setState((prev) => ({
                                  ...prev,
                                  reqFeeStructureList: newFeeStructureList,
                                }));
                              }}
                            />
                          }
                          label={`${item?.feeCode} (${IndianCurrency(
                            item?.feeAmount
                          )})`}
                          componentsProps={{
                            typography: {
                              fontSize: "14px",
                              fontWeight: 600,
                            },
                          }}
                        />
                      </Box>
                    ))}
                  </CustomSelectBox>
                  {state?.reqFeeStructureList?.length > 0 && (
                    <Stack
                      spacing={1}
                      direction="row"
                      mt={1}
                      gap={0.2}
                      flexWrap={"wrap"}
                    >
                      {state?.reqFeeStructureList?.map((docId, index) => {
                        const item = state.feeStructureList.find(
                          (item) => item?._id === docId
                        );
                        return (
                          <Box key={index} sx={{ p: 0.2 }}>
                            <Chip
                              handleClose={() => {
                                const newFeeStructureList =
                                  state.reqFeeStructureList.filter(
                                    (item) => item !== docId
                                  );
                                setState((prev) => ({
                                  ...prev,
                                  reqFeeStructureList: newFeeStructureList,
                                }));
                              }}
                              title={`${item?.feeCode} (${IndianCurrency(
                                item?.feeAmount
                              )})`}
                            />
                          </Box>
                        );
                      })}
                    </Stack>
                  )}
                </Grid>
              </Grid>
            )}
          </Box>
        </DialogContent>
      </CommonFilterDialog>
    </>
  );
};

export default TransportStudentMapFilter;
